/**
 * Temp trip card for column 1 of Temp Trip Feasibility panel.
 */

import React from 'react';
import { MapPin } from 'lucide-react';

function formatDateTime(isoString, timezone = 'America/Los_Angeles') {
  if (!isoString) return '–';
  try {
    return new Date(isoString).toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      timeZone: timezone,
    });
  } catch {
    return isoString;
  }
}

export default function TempTripCard({ trip, timezone }) {
  const clientName = trip.priorityClient?.displayName ?? trip.client_name ?? '–';
  const tripId = trip.tripId ?? trip.trip_id ?? trip._id ?? '–';
  const scheduleTime = trip.scheduleTime ?? trip.schedule_time;
  const appointmentTime = trip.appointmentTime ?? trip.appointment_time;

  return (
    <div className="rounded-lg border border-gray-100 bg-white shadow-sm overflow-hidden text-[11px] hover:shadow-md transition-shadow">
      <div className="p-3 space-y-2">
        <div>
          <div className="font-black text-gray-900 leading-tight">{clientName}</div>
          <div className="text-[10px] font-black text-main-primary uppercase tracking-tight">{tripId}</div>
        </div>
        
        <div className="space-y-1 text-gray-600">
           <div>
             <span className="font-bold text-gray-400 mr-1">Schedule:</span>
             <span className="font-medium">{formatDateTime(scheduleTime, timezone)}</span>
           </div>
           <div>
             <span className="font-bold text-gray-400 mr-1">Appointment:</span>
             <span className="font-medium">{formatDateTime(appointmentTime, timezone)}</span>
           </div>
        </div>

        {trip.jobOriginAddress && (
          <div className="pt-2 border-t border-gray-50 flex items-start gap-1.5 text-gray-700 font-medium leading-tight">
            <span className="shrink-0 text-xs">📍</span>
            <span className="break-words">{trip.jobOriginAddress}</span>
          </div>
        )}
      </div>
    </div>
  );
}
